// extracted by mini-css-extract-plugin
export var addToCartButton = "_l2-b";
export var arrowButtonContainer = "_l2-9";
export var arrowButtonIcon = "_l2-a";
export var carouselArrowButton = "_l2-6";
export var carouselElementContainer = "_l2-1";
export var left = "_l2-7";
export var productDisplayCarouselContainer = "_l2-0";
export var productTileContainer = "_l2-2";
export var productTileImage = "_l2-4";
export var productTileImageContainer = "_l2-3";
export var productTileTitle = "_l2-5";
export var right = "_l2-8";
export var sliderOverflow = "_l2-c";